<template>
  <div>
    <nav>
      <div class="hamburger" @click="openNavBar">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="logo-container">
        <img
          @click="routeToHome"
          alt="Main logo"
          src="../assets/logo.svg"
          class="logo"
        />
      </div>
      <ul class="nav-links">
        <li>
          <a class="hvr-float" @click="openNavBar"
            ><router-link to="/about-us">About Us</router-link></a
          >
        </li>
        <li>
          <a class="hvr-float" @click="openNavBar"
            ><router-link to="/projects">Projects</router-link></a
          >
        </li>
        <li>
          <a class="hvr-float" @click="openNavBar"
            ><router-link to="/consultancy">Consultancy</router-link></a
          >
        </li>
        <li>
          <a class="hvr-float" @click="openNavBar"
            ><router-link to="/testimonials">Testimonials</router-link></a
          >
        </li>
        <li>
          <a class="hvr-float" @click="openNavBar"
            ><router-link to="/contact-us">Contact Us</router-link></a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  methods: {
    routeToHome: function() {
      if (this.$router.currentRoute.name != "home") {
        this.$router.push("/");
      }
    },
    openNavBar: function() {
      console.log("inside openNavBar");
      const navLinks = document.querySelector(".nav-links");
      const links = document.querySelectorAll(".nav-links li");

      navLinks.classList.toggle("open");
      links.forEach((link) => {
        link.classList.toggle("fade");
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");

.logo {
  height: 100%;
  width: 100%;
  margin-top: 15px;
  margin-left: -24px;
}
.logo:hover {
  cursor: pointer;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Poppins";
  /*background-color: black;*/
  /*border: 1px solid red;*/
}

nav {
  height: 88px;
  width: 100vw;
  position: fixed;
  transition: all 400ms ease-out;
  z-index: 10;
  background: #eeeeee;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);
}

nav .logo-container {
  margin-top: auto;
  margin-bottom: auto;
  position: absolute;
  height: 70%;
  width: 10vw;
  /* background-color: black; */
  display: block;
  /*align-items: center;*/
  margin-left: 10vw;
  /* ///// */
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
}

.logo-container a {
  text-decoration: none;
  color: black;
}

.nav-links {
  list-style: none;
  display: flex;

  height: 100%;
  width: 50vw;
  justify-content: space-around;
  align-items: center;
  margin-left: auto;
  margin-right: 10vw;
}

.nav-links li a {
  text-decoration: none;
  font-size: 1rem;
  color: #005570;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
}

.nav-links li a:hover {
  padding-bottom: 14px;
}

.hvr-float {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.hvr-float:hover,
.hvr-float:focus,
.hvr-float:active {
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px);
}
.hamburger {
  display: none;
}
@media screen and (max-width: 1300px) {
  .nav-links {
    width: 70vw;
  }
}
@media screen and (max-width: 900px) {
  .nav-links {
    width: 70vw;
  }
  .nav-links li a {
    font-size: 0.75rem;
  }
}
@media screen and (max-width: 500px) {
  .logo {
    height: 100%;
    width: 157%;
    margin-top: 11px;
    margin-left: 0;
  }
  .line {
    width: 30px;
    height: 3px;
    background: rgb(0, 0, 0);
    margin: 5px;
  }

  nav {
    -webkit-transform: translateZ(0);
    position: fixed;
    top: 0;
    height: 10vh;
  }

  .hamburger {
    display: block;
    position: absolute;
    cursor: pointer;
    right: 5%;
    top: 50%;
    transform: translate(-5%, -50%);
    z-index: 20;
  }

  .nav-links {
    background-color: #eeeeee;
    position: fixed;
    margin: 0;
    padding-bottom: 20vh;
    height: 110vh;
    width: 100vw;
    flex-direction: column;
    clip-path: circle(100px at 90% -10%);
    -webkit-clip-path: circle(100px at 90% -20%);
    transition: all 0.4s ease-out;
    pointer-events: none;
  }

  .nav-links.open {
    clip-path: circle(1200px at 90% -10%);
    -webkit-clip-path: circle(1200px at 90% -10%);
    pointer-events: all;
  }

  .nav-links li {
    opacity: 0;
  }

  .nav-links li a {
    font-size: 20px;
    color: #005570;
  }

  .nav-links li:nth-child(1) {
    transition: all 0.5s ease 0.1s;
  }

  .nav-links li:nth-child(2) {
    transition: all 0.5s ease 0.2s;
  }

  .nav-links li:nth-child(3) {
    transition: all 0.5s ease 0.3s;
  }

  li.fade {
    opacity: 1;
  }
}
</style>
